module.exports = __webpack_public_path__ + "static/media/lavarAsMaos.52b4ca3a.jpg";